import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import { InvoiceButtons } from "../Common/InvoiceButtons";
import InvoiceAddSection from "./InvoiceAddSection";
import InvoiceAmountSection from "./InvoiceAmountSection";
import InvoiceHead from "./InvoiceHead";
import InvoiceTableBody from "./InvoiceTableBody";
import InvoiceTableHead from "./InvoiceTableHead";

const Invoice3Container = () => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  const handlePrint = useReactToPrint({ contentRef });
  return (
    <>
      <Container className="invoice-3 mb-4">
        <Row>
          <Col sm="12">
            <div ref={contentRef}>
              <Card>
                <CardBody>
                  <Table borderless>
                    <tbody>
                      <InvoiceHead />
                      <InvoiceAddSection />
                      <tr>
                        <td className="p-0">
                          <Table borderless style={{ width: "100%", borderSpacing: 0 }}>
                            <InvoiceTableHead />
                            <InvoiceTableBody />
                          </Table>
                        </td>
                      </tr>
                      <InvoiceAmountSection />
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
      <InvoiceButtons handlePrint={handlePrint} />
    </>
  );
};

export default Invoice3Container;
